import { type FC } from "react";
import { cn } from "@/components/podkit/lib/cn";
import type { PlainMessage } from "@bufbuild/protobuf";
import type { WorkflowTrigger } from "gitpod-next-api/gitpod/v1/workflow_pb";
import { Tooltip } from "@/components/Tooltip";
import { triggerIcon, triggerLabel } from "@/utils/automations";

type AutomationTriggerIconProps = {
    trigger?: PlainMessage<WorkflowTrigger>;
    size?: number;
    className?: string;
};

export const AutomationTriggerIconWithTooltip: FC<AutomationTriggerIconProps> = ({ trigger, size = 32, className }) => {
    const Icon = triggerIcon(trigger);
    const label = triggerLabel(trigger);

    return (
        <Tooltip content={label} usePortal>
            <div
                className={cn(
                    "flex shrink-0 items-center justify-center rounded-full border border-border-subtle bg-surface-base text-content-secondary",
                    className,
                )}
                style={{ width: size, height: size }}
                aria-label={label}
            >
                <Icon size={size * 0.5} />
            </div>
        </Tooltip>
    );
};
